jQuery(function ($) {
  console.log("feedback-slideout-card.js disabled");
  return;
  console.log("feedback-slideout-card.js loaded");

  let stickyTag;
  let modal;
  let type;

  // Get modal type from hidden div injected by PHP: home, publications, data-tool
  if ($('#idea-feedback-modal-type').length > 0) {
    type = $('#idea-feedback-modal-type').data('type');
    $('#idea-feedback-modal-type').remove();
  } else {
    return;
  }

  // Check localStorage for last shown timestamp
  const lastShownTimeStamp = localStorage.getItem('idea-feedback-modal-last-shown-timestamp_' + type);
  const currentTimeStamp = Date.now();

  // Show the modal only if it hasn't been shown in the last 7 days, lastShownTimeStamp is undefined, or null
  if (lastShownTimeStamp && (currentTimeStamp - lastShownTimeStamp) < 7 * 24 * 60 * 60 * 1000) {
    console.log('Feedback modal for type "' + type + '" was shown less than 7 days ago. Not showing again.');
    return;
  }

  const modalContents = {
    'home': {
      title: 'Help us improve your experience',
      message1: "We've recently updated our website and logo. Your first impressions are essential for helping us create a better, more user-friendly site.",
      message2: "Would you be willing to take a quick, 4-minute survey?",
      url: 'https://www.surveymonkey.com/r/iideawl25-br',
    },
    'publications': {
      title: 'What do you think of our publications?',
      message1: "Your feedback helps us create better resources.",
      message2: "Tell us what you think in this quick, 3-4 minute survey.",
      url: 'https://www.surveymonkey.com/r/iideapub25-br',
    },
    'data-tool': {
      title: 'Help us improve our Databases & Tools',
      message1: "We want to ensure our databases and tools are as effective as possible for your research.",
      message2: "Please share your insights in our quick, 3-4 minute survey.",
      url: 'https://www.surveymonkey.com/r/iideadt25-br',
    },
  }

  // Function to spawn the sticky tag
  function spawnStickyTag() {
    let html = `
      <button class="idea--feedback--sticky-tag bg-ideaBlue100 text-white flex items-center text-mobileS md:text-desktopS leading-none font-bold gap-2 px-4 py-2 rounded-tl-lg rounded-tr-lg border border-white transition-all duration-500 hover:bg-ideaBlue100Hover cursor-pointer">
        <img src="/themes/custom/tema/src/assets/icons/icon-feedback-alt.svg" alt="Icon" class="idea--feedback--icon">
      </button>
      `;
    stickyTag = $(html).appendTo('body');

    html = `
      <div class="idea--feedback--modal bg-white rounded-md p-8 fixed bottom-8 right-8 z-50">
        <div class="flex items-center justify-start gap-4">
          <div class="bg-ideaBackgroundGrey100 rounded-full idea--feedback--large-icon bg-no-repeat bg-center flex-shrink-0"></div>
          <h3 class="h3 !mb-0">${modalContents[type].title}</h3>
        </div>
        <p class="text-mobileM md:text-desktopM">${modalContents[type].message1}</p>
        <p class="font-medium italic">${modalContents[type].message2}</p>
        <div class="flex flex-wrap gap-2 mt-8">
          <a href="${modalContents[type].url}" class="btn btn-s--pill w-full sm:w-auto" target="_blank" rel="noopener noreferrer">Give Feedback</a>
          <button id="maybe-later" class="btn btn-s--pill btn-c--hollow w-full sm:w-auto">Maybe later</button>
        </div>
        <button class="absolute top-2 right-2" id="close-feedback-modal">
          <img src="/themes/custom/tema/src/assets/icons/icon-close-tooltip.svg" alt="Close" style="width: 40px;" class="hover:opacity-70 transition-opacity duration-300">
        </button>
      </div>
    `;
    modal = $(html).appendTo('body');

    $('#maybe-later').on('click', function(){
      modal.removeClass('active');

      // Store the current timestamp in localStorage
      const currentTimeStamp = Date.now();
      localStorage.setItem('idea-feedback-modal-last-shown-timestamp_' + type, currentTimeStamp);

      setTimeout(() => {
        modal.remove();
        stickyTag.remove();
      }, 100);
    });

    $('#close-feedback-modal').on('click', function(){
      modal.removeClass('active');
      stickyTag.addClass('active');
    });

    stickyTag.on('click', function(){
      stickyTag.removeClass('active');

      // setTimeout(() => {
        modal.addClass('active');
      // }, 100);
    });

    setTimeout(() => {
      modal.addClass('active');
    }, 100);
  }

  setTimeout(() => {
    spawnStickyTag();
  }, 2500);
});
// Document.ready END
///////////////////////////////////////////////////////////////////////////////
